import React from 'react';

import { useUserStatusContext } from '../../../../context/UserStatus';
import { IAMListRole } from '../../../IAM/types';
import { ExternalUserListItem } from '../../types';
import EditUser from './EditUser';

export interface UserDetailsProps {
    userName: string;
    closeModal: () => void;
    roles?: IAMListRole[];
    user: ExternalUserListItem;
    isLoggedUser?: boolean;
}

const UserDetails: React.FC<Omit<UserDetailsProps, 'isLoggedUser'>> = ({
    user,
    userName,
    closeModal,
    roles
}) => {
    const { userStatus } = useUserStatusContext();

    return (
        <EditUser
            user={user}
            userName={userName}
            closeModal={closeModal}
            roles={roles}
            isLoggedUser={userStatus?.email === user.email}
        />
    );
};

export default UserDetails;
